import React from 'react'
import Text from '@component/Text/Text'
import {TableHeaderContainer} from '@component/tables/TableHeaderContainer'
import {useTranslation} from '@lib/intl/useTranslations'

interface IProps {
    className?: string
}

const LeagueLeaderboardHeaderContainer: React.FC<IProps> = ({className}) => {
    const t = useTranslation()
    return (
        <TableHeaderContainer
            className={
                'grid grid-cols-[50px_300px_auto_150px_162px] md:grid-cols-[35px_auto_100px] gap-[10px] my-[10px] md:px-[10px] md:gap-x-[5px]'
            }>
            <Text className={'text-ti2 text-gray02 dark:text-dark_gray02 text-center md:text-left md:text-ti3'}>
                {t('leaderboard.table.title.rank')}
            </Text>
            <Text className={'text-ti2 text-gray02 dark:text-dark_gray02 md:text-ti3'}>
                {t('leaderboard.table.title.name')}
            </Text>
            <Text className={'text-ti2 text-gray02 dark:text-dark_gray02 md:hidden'}>
                {t('leaderboard.table.title.exchange')}
            </Text>
            <Text className={'text-ti2 text-gray02 dark:text-dark_gray02 text-right md:text-ti3'}>
                {t('leaderboard.table.title.profit')}
            </Text>
            <div className={'block md:hidden'} />
        </TableHeaderContainer>
    )
}
export default React.memo(LeagueLeaderboardHeaderContainer)
